<template lang="pug">
.receipt-item-fieldset
  v-form(ref="form")
    v-container
      v-slide-y-transition.px-0(
        group
        tag="v-container")
        v-layout.receipt-item-fieldset__item-fieldset.mb-4(
          v-for="(item, index) in items"
          :key="`receipt-item-${index}`"
          wrap)
          v-flex.text-xs-center(
            xs5
            sm2
            md1)
            div
              v-avatar.white--text.font-weight-bold(
                color="info"
                size="30") {{ index + 1}}
            div
              v-btn(
                v-if="index !== 0"
                color="error"
                icon
                fab
                @click="removeItem(index)")
                v-icon remove
          v-flex(
            xs12
            sm5
            md2)
            v-select(
              v-model="items[index].year"
              :items="yearItems"
              :error-messages="getYearErrors(index)"
              item-value="value"
              item-text="text"
              label="項目年度*"
              outline
              @input="$v.items.$each[index].year.$touch()"
              @blur="$v.items.$each[index].year.$touch()")
          v-flex.receipt-item-fieldset__btn-delete(
            xs12
            sm5
            md3)
            v-select(
              v-model="items[index].type"
              :items="receiptTypesItems"
              :error-messages="getTypeErrors(index)"
              item-value="value"
              item-text="text"
              label="項目*"
              outline
              @input="$v.items.$each[index].type.$touch()"
              @blur="$v.items.$each[index].type.$touch()")
          v-flex(
            v-if="items[index].type === 'donation'"
            xs12
            sm6
            md3)
            v-text-field(
              v-model="items[index].donation"
        
              label="樂捐項目"
              outline
              @input="$v.items.$each[index].donation.$touch()"
              @blur="$v.items.$each[index].donation.$touch()")
            v-chip(@click="items[index].donation = '職務捐'") 職務捐
            v-chip(@click="items[index].donation = '輪值捐'") 輪值捐
          v-flex(
            v-if="items[index].type === 'other'"
            xs12
            sm6
            md3)
            v-text-field(
              v-model="items[index].other"
              :error-messages="getOtherErrors(index)"
              label="其他*"
              outline
              @input="$v.items.$each[index].other.$touch()"
              @blur="$v.items.$each[index].other.$touch()")
          v-flex(
            xs12
            sm6
            md3)
            v-text-field(
              v-model="items[index].payment"
              :error-messages="getAmountErrors(index)"
              label="繳交金額*"
              outline
              @input="$v.items.$each[index].payment.$touch()"
              @blur="$v.items.$each[index].payment.$touch()")
      v-layout(v-if="numItems < 5")
        v-flex
          v-btn(
            color="warning"
            outline
            @click="addItem")
            v-icon add
            span 新增繳費項目
</template>
<script>
import { validationMixin } from "vuelidate";
import {
  required,
  numeric,
  minValue,
  maxValue
} from "vuelidate/lib/validators";
import { ref } from "@/utils/validators";
import formBuilder from "@/utils/formBuilder";
import RECEIPT_TYPES from "@/assets/tables/receipt_types.json";
import moment from "moment";

function getItemDefaultYear() {
  // 會員大會通常在 11 月舉辦，即會跳下一個年度，所以這邊算法加 2 個月
  return (
    moment()
      .add(2, "month")
      .year() - 1911
  );
}

export default {
  name: "ReceiptItemFieldset",
  validations: {
    items: {
      required,
      $each: {
        year: {
          required,
          numeric,
          minValue: minValue(getItemDefaultYear() - 2),
          maxValue: maxValue(getItemDefaultYear() + 2)
        },
        type: { required },
        // 20200817 改為可空白
        // donation: {
        //   required: ref("type", (value, ref) =>
        //     ref === "donation" ? !!value : true
        //   )
        // },
        other: {
          required: ref("type", (value, ref) =>
            ref === "other" ? !!value : true
          )
        },
        payment: { required, numeric, minValue: minValue(1) }
      }
    }
  },
  mixins: [validationMixin],
  props: {
    initItems: {
      type: Array,
      default: () => [
        {
          year: getItemDefaultYear(),
          type: null,
          other: null,
          payment: null,
          donation: null
        }
      ]
    }
  },
  data() {
    return {
      receiptTypesItems: Object.entries(RECEIPT_TYPES).map(item => item[1]),
      items: this.initItems
    };
  },
  computed: {
    yearItems() {
      const thisY = getItemDefaultYear();
      return [thisY - 2, thisY - 1, thisY, thisY + 1, thisY + 2];
    },
    numItems() {
      return this.items.length;
    }
  },
  methods: {
    getYearErrors(index) {
      const errors = [];
      const $v = this.$v.items.$each[index].year;
      if (!$v.$dirty) return errors;
      !$v.required && errors.push("請選擇項目年度");
      !$v.numeric && errors.push("請輸入數字");
      !$v.minValue && errors.push("請輸入正確年度");
      !$v.maxValue && errors.push("請輸入正確年度");
      return errors;
    },
    getTypeErrors(index) {
      const errors = [];
      const $v = this.$v.items.$each[index].type;
      if (!$v.$dirty) return errors;
      !$v.required && errors.push("請選擇繳款項目");
      return errors;
    },
    // getDonationErrors(index) {
    //   const errors = [];
    //   const $v = this.$v.items.$each[index].donation;
    //   if (!$v.$dirty) return errors;
    //   !$v.required && errors.push("請輸入樂捐項目");
    //   return errors;
    // },
    getOtherErrors(index) {
      const errors = [];
      const $v = this.$v.items.$each[index].other;
      if (!$v.$dirty) return errors;
      !$v.required && errors.push("請輸入自訂項目");
      return errors;
    },
    getAmountErrors(index) {
      const errors = [];
      const $v = this.$v.items.$each[index].payment;
      if (!$v.$dirty) return errors;
      !$v.required && errors.push("請輸入繳交金額");
      !$v.numeric && errors.push("請輸入數字");
      !$v.minValue && errors.push("請輸入正確金額");
      return errors;
    },
    addItem() {
      if (this.numItems < 5) {
        this.items.push({
          year: getItemDefaultYear(),
          type: null,
          donation: null,
          other: null,
          payment: null
        });
      }
    },
    removeItem(index) {
      if (index !== 0) {
        this.items.splice(index, 1);
      }
    },
    reset() {
      this.$refs.form.reset();
      this.$v.$reset();
    },
    submit() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return false;
      }

      return JSON.parse(JSON.stringify(this.items));
    }
  }
};
</script>

<style lang="styl">
.receipt-item-fieldset
  &__item-fieldset
    .flex
      padding 8px
    .v-btn
      height 30px
      width 30px
</style>
